import React from 'react';
import { Box, Typography } from '@mui/material';

export const InvoicesPage: React.FC = () => {
    return (
        <Box>
            <Typography variant="h4" component="h1" gutterBottom>
                Facturas
            </Typography>
            <Typography variant="body1">
                Gestión de facturas - En desarrollo
            </Typography>
        </Box>
    );
}; 